module.exports = __webpack_public_path__ + "img/b43ff85e-ac2a-4030-8131-0e27833ad404.bda99b31.jpg";